import {Colors, createTheme} from '@rneui/themed';
import {RecursivePartial} from '@rneui/themed/dist/config/theme';

import theme from './theme';

const reactNativeElementsThemeColours: RecursivePartial<Colors> = {
  primary: theme.colour.uiControls.primary,
  secondary: theme.colour.uiControls.secondary,
};

export const reactNativeElementsTheme = createTheme({
  lightColors: reactNativeElementsThemeColours,
  darkColors: reactNativeElementsThemeColours,
  mode: 'light',
});
